import { render, staticRenderFns } from "./QPage.vue?vue&type=template&id=7dccb617&scoped=true&"
import script from "./QPage.vue?vue&type=script&lang=js&"
export * from "./QPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dccb617",
  null
  
)

export default component.exports